module.exports = __webpack_public_path__ + "static/media/red_x.f67afe35.svg";